import { findMultiplet } from './findMultiplet';
/**
 * convert from pattern name to only one letter abbreviation or any supported abbreviation to pattern name.
 * @param name - pattern name or abbreviation.
 * @returns
 */
export function translateMultiplet(name) {
    const multiplet = findMultiplet(name);
    if (!multiplet) {
        throw new Error(`multiplet ${name} is not supported`);
    }
    const { value, label } = multiplet;
    return name === label ? value : label;
}
//# sourceMappingURL=translateMultiplet.js.map